import qs from 'qs';

import actionTypes from 'Redux/constants';

import http from 'utlis/http';

export const getDesignAuditCountsAction = () => async dispatch => {
  try {
    const config = {
      method: 'get',
      url: `${process.env.REACT_APP_BASE_URL}/api/v1/project/design-audits/count/`,
    };

    const response = await http(config);

    dispatch({
      type: actionTypes.GET_DESIGN_AUDIT_COUNTS,
      payload: response.data,
    });

    return response.data;
  }
  catch (error) {
    const defaultCounts = {
      reviews_this_month: 0,
      reviews_in_progress: 0,
      reviews_completed: 0,
      customer_name: 'Unknown',
    };

    dispatch({
      type: actionTypes.GET_DESIGN_AUDIT_COUNTS,
      payload: defaultCounts,
    });

    return defaultCounts;
  }
};

export const getDesignAuditHistoryAction = (
  days,
  page,
  pageSize,
  search = null,
  reviewStatus = null
) => async dispatch => {
  try {
    const params = {
      days,
      page,
      page_size: pageSize,
    };

    // Add search parameter if provided and not empty
    if (search && search.trim()) {
      params.search = search.trim();
    }

    // Add reviewStatus parameter if provided
    if (reviewStatus !== null && reviewStatus !== undefined) {
      params.status = reviewStatus;
    }

    const queryParams = qs.stringify(params);

    const config = {
      method: 'get',
      url: `${process.env.REACT_APP_BASE_URL}/api/v1/project/design-audits/history/?${queryParams}`,
    };

    const response = await http(config);

    dispatch({
      type: actionTypes.GET_DESIGN_AUDIT_HISTORY,
      payload: response.data,
    });

    return response.data;
  }
  catch (error) {
    const defaultHistory = {
      count: 0,
      next: null,
      previous: null,
      results: [],
    };

    dispatch({
      type: actionTypes.GET_DESIGN_AUDIT_HISTORY,
      payload: defaultHistory,
    });

    return defaultHistory;
  }
};
